/**
* 用户
*/
const user = {
  
createUser: "/api/createUser",//创建
getUserInfo: "/api/getUserInfo",//查询用户信息
modifyUserInfo: "/api/modifyUserInfo",//修改信息
modifyUserEmailAddress: "/api/modifyUserEmailAddress",//修改邮箱
modifyUserPhoneNumber: "/api/modifyUserPhoneNumber",//修改手机号码
modifyUserPassword: "/api/modifyUserPassword",//修改密码
resetUserPassword: "/api/resetUserPassword",//重置密码
getUserOriginFrontEndPagePrivileges: "/api/getUserOriginFrontEndPagePrivileges",//查询用户原始前端页面权限
setUserOriginFrontEndPagePrivileges: "/api/setUserOriginFrontEndPagePrivileges",//设置用户原始前端页面权限
listCompaniesOfICreated: "/api/listCompaniesOfICreated",//查询我创建的公司
listCompaniesOfIJoined: "/api/listCompaniesOfIJoined",//查询我加入的公司
getAccessibleCompany:'/api/getAccessibleCompany'
}

export default user